(() => {
  if (customElements.get('product-bar')) {
    return;
  }

  class ProductBar extends HTMLElement {
    static VISIBLE_CLASS = 'is-visible';

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    detachEvents() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    init() {
      this.options = this.querySelector('[data-options]');
      this.form = this.querySelector('form');
      this.productSection = document.querySelector('.product');
      this.productSelector = this.querySelector('product-selector');

      if (this.productSection) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.toggleVisible(!entry.isIntersecting);
          });
        });

        this.observer.observe(this.productSection);
      }
    }

    toggleVisible(isVisible) {
      this.classList.toggle(ProductBar.VISIBLE_CLASS, isVisible);
    }

    isOutOfViewport(element) {
      const rect = element.getBoundingClientRect();

      return (
        rect.bottom < 0 ||
        rect.top > window.innerHeight ||
        rect.right < 0 ||
        rect.left > window.innerWidth
      );
    }

    update(currentVariant, currentVariantPrice, currentSellingPlan) {
      const variantIdField = this.form?.elements['id'];
      const sellingPlanField = this.form?.elements['selling_plan'];

      if (variantIdField) {
        variantIdField.value = currentVariant.id;
      }

      if (sellingPlanField) {
        sellingPlanField.value = currentSellingPlan;
      }

      if (this.options) {
        this.options.replaceChildren();

        this.options.textContent = currentVariant.options.join(', ');
      }

      if (this.productSelector) {
        this.productSelector.currentVariant = currentVariant;
        this.productSelector.currentVariantPrice = currentVariantPrice;

        this.productSelector.toggleAddButton(false, '');

        if (!currentVariant) {
          this.productSelector.toggleAddButton(true, '');
          this.productSelector.setUnavailable();

          return;
        }

        if (!currentVariant.available) {
          this.productSelector.toggleAddButton(
            true,
            window.variantStrings.soldOut,
          );
        }
      }
    }
  }

  customElements.define('product-bar', ProductBar);
})();
